import { useCallback, useEffect, useState } from 'react';
import { USERS } from '../data/users';

const STORAGE_KEY = 'pbp_logged_user';

export function useAuthInternal() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }

    try {
      const raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw) {
        setLoading(false);
        return;
      }

      const parsed = JSON.parse(raw);
      if (parsed && parsed.username) {
        setUser(parsed);
      }
    } catch (e) {
      // ignorujemy błędy JSON/localStorage
    } finally {
      setLoading(false);
    }
  }, []);

  const login = useCallback((username, password) => {
    setError('');

    const found = USERS.find(
      (u) => u.username === username && u.password === password
    );

    if (!found) {
      setError('Nieprawidłowy login lub hasło.');
      return false;
    }

    const payload = {
      username: found.username,
      role: found.role,
      firstName: found.firstName,
      lastName: found.lastName,
      position: found.position,
      phone: found.phone,
      email: found.email,
    };

    if (typeof window !== 'undefined') {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
    }

    setUser(payload);
    return true;
  }, []);

  const logout = useCallback(() => {
    if (typeof window !== 'undefined') {
      window.localStorage.removeItem(STORAGE_KEY);
    }
    setUser(null);
  }, []);

  return {
    user,
    loading,
    error,
    login,
    logout,
    setError,
  };
}

